import provinces from "../../data/provinces_th.json";

const getProvinceTH = async (req, res) => {
  try {
    return provinces.map((prov) => ({
      id: prov.id,
      name_en: prov.name_en,
      name: prov.name_th,
    }));
  } catch (error) {
    console.error("Error fetching province data:", error);
    res.status(500).json({ error: "Failed to fetch province data" });
  }
};

const ProvinceTHService = {
  getProvinceTH,
};

export default ProvinceTHService;
